import React, { useEffect, useState } from 'react';
import { Form, Typography, Modal, Row, InputNumber, Card } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import TextArea from 'antd/lib/input/TextArea';

import {
  objectLabelToString,
  objectParValueToString,
  shouldUpdateCompare,
} from 'utils/utils2';
import ParListSelectWithLabelInValue from 'components/ParListSelectWithLabelInValue';
import FormInput from 'components/FormInput';
import { toCurrency } from '../../../utils/utils';
import ThirdPartyInput from 'components/ThirdPartyInput';
import ParListSelect from 'components/ParListSelect';
import InputCurrency from 'components/InputCurrency';
import TaxSelect from 'components/TaxSelect';
import { useAttributeContextFramework } from 'DisplayFramework/hooks/useAttribute';
import { isBoolean, isNil, isNumber } from 'lodash';
import {
  EntityAdditionalAttributeRequest,
  ViewEntityAddAttributeResponse,
} from 'services/assets';
import moment from 'moment';
import _ from 'lodash';
import GetLabel from 'DisplayFramework/components/GetLabel';

const Text = Typography;

export type SimpleAssetModalProps = {
  flagreal: boolean;
  visible: boolean;
  onCancel: () => void;
  onAdd: (asset: any) => void;
  currcode?: string;
  supplier?: any;
  assetclass?: string;
  assetsegmentParent?:string;
};

const SimpleAssetModal = (props: SimpleAssetModalProps) => {
  const { visible, onCancel, onAdd, currcode, supplier, assetclass,assetsegmentParent } = props;

  const [form] = useForm();

  const [taxrate, settaxrate] = useState<number>(0);

  const [state, setState] = useState<any>({
    attid: 0,
    assetfamily: { value: '', label: '' },
    assettype: { value: '', label: '' },
    assetcategory: { value: '', label: '' },
    assetmodel: { value: '', label: '' },
    assetsegment: { value: '', label: '' },
  });

  const handleAdd = () => {
    form.submit();
  };
  useEffect(() => {
    if (currcode)
      form.setFieldsValue({
        currcode: currcode,
        assetdescription:
          form.getFieldValue('assetdescription') === ''
            ? form.getFieldValue('assetlabel')
            : form.getFieldValue('assetdescription'),
      });
  }, [currcode, supplier, form]);

  const { data: attlist } = useAttributeContextFramework(
    'ASSET',
    'ASSET',
    '',
    '',
    objectParValueToString(state.assetfamily) ?? '',
    objectParValueToString(state.assettype) ?? '',
    objectParValueToString(state.assetcategory) ?? '',
    objectParValueToString(state.assetsegment) ?? '',
    objectParValueToString(state.assetmodel) ?? ''
  );

  const handleFinish = (values: any) => {
    let test = {};
    let entityAddAttributList: EntityAdditionalAttributeRequest[] = [];

    if (!isNil(attlist)) {
      attlist?.forEach((att: ViewEntityAddAttributeResponse) => {
        let value: any;

        if (att.attdatatype === 'STRING') {
          value = att.defautvalue;
        } else if (att.attdatatype === 'LONG') {
          value = att.defautvalue;
        } else if (att.attdatatype === 'DOUBLE') {
          value = att.defautvalue;
        } else if (att.attdatatype === 'BOOLEAN') {
          value = att.defautvalue;
        } else if (att.attdatatype === 'TEXT') {
          value = att.defautvalue;
        } else if (att.attdatatype === 'DATE') {
          if (moment(att.defautvalue, false).isValid()) {
            value = moment(att.defautvalue, false);
          } else {
            value = null;
          }
        }

        if (!isNil(att.defautvalue)) {
          let attnumericvalue: number = 0;
          let atttextvalue: string = '';
          let attbooleanvalue = null;
          let attstringvalue: string = '';
          if (isBoolean(value)) {
            attbooleanvalue = Boolean(value);
          } else if (isNumber(value)) {
            attnumericvalue = Number(value);
          } else if (String(value)?.length < 100) {
            attstringvalue = value;
            //atttextvalue = entityAddAttribut[key];
          } else {
            atttextvalue = value;
          }

          let entityAddAttributData: EntityAdditionalAttributeRequest = {
            attbooleanvalue: attbooleanvalue ?? false,
            attcode: att.attcode,
            attnumericvalue: attnumericvalue,
            attstringvalue: attstringvalue,
            atttextvalue: atttextvalue,
            attdatatype: att.attdatatype,
            entity: att?.entity ?? '',
            entityid: att?.entityid ?? 0,
            id: 0,
          };

          entityAddAttributList.push(entityAddAttributData);
        }
      });
    }
    onAdd({
      ...values,
      assetdescription:
        values.assetdescription === '' || values.assetdescription == null
          ? values.assetlabel
          : values.assetdescription,
      assetcategory: objectParValueToString(values.assetcategory),
      assetcategorylabel: objectLabelToString(values.assetcategory),
      assetfamily: objectParValueToString(values.assetfamily),
      assetfamilylabel: objectLabelToString(values.assetfamily),
      assetsegmentlabel: objectLabelToString(values?.assetsegment),
      assetsegment: objectParValueToString(values?.assetsegment),
      assetclass: values?.assetclass,
      assetComponents: [],
      assetconstructor: '',
      assetconstructorreference: '',
      assetdiscountamount: '',
      assetdiscountperc: '',
      assetgrossamountorigine: '',
      assetgrossamount: form.getFieldValue('assetgrossamount'),
      assetid: Math.floor(_.random(10000) * 1000000),
      assetmodel: objectParValueToString(values?.assetmodel),
      assetnetamountorigine: '',
      assetpictureurl: '',
      assettype: values.assettype.value,
      assettypelabel: values.assettype.label,
      assetvariant: '',
      catalogid: null,
      catalogstatus: '',
      enddate: '',
      startdate: '',
      suppliername: values.supplier ? values.supplier.tpname : null,
      taxcode: values.taxcode,
      taxrate: taxrate,
      assetstatus: 'INIT',
      statuslabel: 'Initial',
      assetstatuslabel: 'Initial',
      tpidsupplier: values.supplier ? values.supplier.tpid : null,
      supplierreference: values.supplier ? values.supplier.tpreference : null,
      assetqty: values.assetqty !== undefined ? values.assetqty : 1,
      entityAddAttribut: entityAddAttributList ?? [],
    });
    settaxrate(0);
  };

  const initialValues = {
    assettype: '' as any,
    assetcategory: '' as any,
    assetfamily: '' as any,
    assetlabel: '',
    assetsegment: '' as any,
    assetdescription: '',
    assetnetamount: 0,
    assettaxamount: 0,
    assetgrossamount: 0,
    supplier: supplier ?? ('' as any),
    assetclass: assetclass ?? '',
  };

  return (
    <Modal
      visible={visible}
      title={<GetLabel label="Add asset" />}
      onOk={handleAdd}
      okText="Add"
      onCancel={onCancel}
      width="700px"
      style={{ top: 20 }}
      destroyOnClose
    >
      <Card>
        <Form
          form={form}
          component={false}
          onFinish={handleFinish}
          layout="vertical"
          initialValues={initialValues}
          labelCol={{ span: 24 }}
          preserve={false}
        >
          <Row gutter={[8, 0]}>
            <FormInput
              col
              xl={8}
              name="assetsegment"
              rules={[{ required: true }]}
              comcode="assetsegment"
            >
              <ParListSelectWithLabelInValue
                parcode="ASSETPRD"
                onChange={(e) => {
                  form.setFieldsValue({
                    assetfamily: '',
                    assettype: '',
                    assetcategory: '',
                  });
                  setState({
                    ...state,
                    assetsegment: e,
                    assetfamily: '',
                    assettype: '',
                    assetcategory: '',
                    assetmodel: '',
                  });
                }}
                parvalueparent={assetsegmentParent}
              />
            </FormInput>
            <Form.Item
              shouldUpdate={shouldUpdateCompare('assetsegment')}
              noStyle
            >
              {({ getFieldValue }) => (
                <FormInput
                  col
                  xs={8}
                  name="assetfamily"
                  rules={[{ required: true }]}
                  comcode="assetfamily"
                >
                  <ParListSelectWithLabelInValue
                    parcode="ASSETFAM"
                    parvalueparent={objectParValueToString(
                      getFieldValue('assetsegment')
                    )}
                    disabled={!getFieldValue('assetsegment')?.value}
                    onChange={(e) => {
                      form.setFieldsValue({
                        assettype: '',
                        assetcategory: '',
                      });
                      setState({
                        ...state,
                        assetfamily: e,
                        assettype: '',
                        assetcategory: '',
                        assetmodel: '',
                      });
                    }}
                    onlywithparvalueparent
                  />
                </FormInput>
              )}
            </Form.Item>
            <Form.Item
              shouldUpdate={shouldUpdateCompare('assetfamily')}
              noStyle
            >
              {({ getFieldValue }) => (
                <FormInput
                  col
                  xs={24}
                  sm={8}
                  name="assettype"
                  rules={[{ required: true }]}
                >
                  <ParListSelectWithLabelInValue
                    parcode="ASSETTYPE"
                    parvalueparent={objectParValueToString(
                      getFieldValue('assetfamily')
                    )}
                    disabled={!getFieldValue('assetfamily')?.value}
                    onChange={(e) => {
                      form.setFieldsValue({ assetcategory: '' });
                      setState({
                        ...state,
                        assettype: e,
                        assetcategory: '',
                        assetmodel: '',
                      });
                    }}
                    onlywithparvalueparent
                  />
                </FormInput>
              )}
            </Form.Item>
            <Form.Item shouldUpdate={shouldUpdateCompare('assettype')} noStyle>
              {({ getFieldValue }) => (
                <FormInput
                  col
                  xs={24}
                  md={8}
                  name="assetcategory"
                  comcode="assetcategory"
                  rules={[{ required: true }]}
                >
                  <ParListSelectWithLabelInValue
                    parcode="ASSETCAT"
                    disabled={!getFieldValue('assettype')}
                    parvalueparent={objectParValueToString(
                      getFieldValue('assettype')
                    )}
                    onChange={(e) => {
                      setState({
                        ...state,
                        assetcategory: e,
                      });
                    }}
                  />
                </FormInput>
              )}
            </Form.Item>

            <FormInput
              col
              xs={24}
              md={8}
              name="assetclass"
              comcode="assetclass"
            >
              <ParListSelect
                disabled={!isNil(assetclass) && assetclass !== ''}
                parcode="ASSETCLASS"
              />
            </FormInput>

            <FormInput
              col
              xs={16}
              name="assetlabel"
              rules={[{ required: true }]}
            />
            <FormInput col xs={12} name="supplier">
              <ThirdPartyInput role="SUPPLIER" disabled={supplier != null} />
            </FormInput>
            <FormInput col xs={24} name="assetdescription">
              <TextArea rows={2} />
            </FormInput>

            <Form.Item shouldUpdate={shouldUpdateCompare('currcode')} noStyle>
              {({ getFieldValue }) => (
                <InputCurrency
                  currcode={getFieldValue('currcode')}
                  fieldname="assetunitnetamount"
                  rules={[{ required: true }]}
                  onChange={(e) => {
                    const netamount =
                      Number(getFieldValue('assetqty') || 1) * Number(e || 0);
                    form.setFieldsValue({
                      assettaxamount: Number((netamount * taxrate) / 100),
                      assetnetamount: netamount,
                    });
                  }}
                  col
                  md={7}
                />
              )}
            </Form.Item>
            <FormInput name="assetqty" col xl={3} shouldUpdate>
              <InputNumber
                defaultValue={1}
                onChange={(e) => {
                  const netamount =
                    Number(e || 1) *
                    Number(form.getFieldValue('assetunitnetamount') || 0);
                  form.setFieldsValue({
                    assettaxamount: Number((netamount * taxrate) / 100),
                    assetnetamount: netamount,
                  });
                }}
              />
            </FormInput>
            <FormInput name="currcode" col xl={6} shouldUpdate>
              <ParListSelect parcode="CURRENCY" />
            </FormInput>
            <FormInput
              name="taxcode"
              col
              xl={6}
              shouldUpdate
              rules={[{ required: true }]}
            >
              <TaxSelect
                taxflow="INOUT"
                onSelected={(tax) => {
                  settaxrate(tax.taxrate);
                  form.setFieldsValue({
                    taxrate: tax.taxrate,
                    assettaxamount:
                      (tax.taxrate * form.getFieldValue('assetnetamount')) /
                      100,
                  });
                }}
              />
            </FormInput>
            <Form.Item
              shouldUpdate={shouldUpdateCompare([
                'currcode',
                'assetqty',
                'assetunitnetamount',
              ])}
              noStyle
            >
              {({ getFieldValue }) => {
                return (
                  <FormInput col xs={7} name="assetnetamount">
                    <Text>
                      {toCurrency(
                        getFieldValue('assetnetamount'),
                        getFieldValue('currcode')
                      )}
                    </Text>
                  </FormInput>
                );
              }}
            </Form.Item>

            <Form.Item
              shouldUpdate={shouldUpdateCompare([
                'currcode',
                'assetunitnetamount',
                'assetnetamount',
              ])}
              noStyle
            >
              {({ getFieldValue }) => (
                <InputCurrency
                  currcode={getFieldValue('currcode')}
                  fieldname="assettaxamount"
                  col
                  md={6}
                />
              )}
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={shouldUpdateCompare([
                'assetnetamount',
                'assettaxamount',
                'currcode',
              ])}
            >
              {({ getFieldValue, setFieldsValue }) => {
                const gross =
                  Number(getFieldValue('assetnetamount') || 0) +
                  Number(getFieldValue('assettaxamount') || 0);

                return (
                  <>
                    <FormInput col xs={8} name="assetgrossamount">
                      <Text>
                        {toCurrency(gross, getFieldValue('currcode'))}
                      </Text>
                    </FormInput>
                    {setFieldsValue({
                      assetgrossamount: gross,
                    })}
                  </>
                );
              }}
            </Form.Item>
          </Row>
        </Form>
      </Card>
    </Modal>
  );
};

export default SimpleAssetModal;
